import { css } from 'react-emotion'

const styles = {
  component: css({
    position: 'absolute',
    top: 0,
    left: 0
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Canvas/CanvasStyles.js